import React from 'react';

const Filter: React.FC<React.PropsWithChildren> = () => (
  <path d="M22 2H2L10 11.46V18L14 20V11.46L22 2Z" strokeWidth="2.54167" strokeLinecap="round" strokeLinejoin="round" />
);

export default Filter;
